import cookie from 'js-cookie'
import mutations from './mutations'
import getters from './getters'
import actions from './actions'

const state = {
  showBubble: false,
  originOrderList: [],

  // 新消息数量
  newMsgNumber: 0,

  // 渠道
  channel: 'Changyoyo_Life_Central',

  // 是否会员
  vip: false,

  // 登录令牌
  token: cookie.get('login_token'),

  // 是否新用户
  newUser: '',

  // 用户畅由积分
  points: 0,

  // 用户优惠券数量
  couponQuantity: 0,

  // 用户电子券数量
  ecardQuantity: 0,

  //  当前环境h5或者app,对应的msgVersion
  appid: '',
  msgVersion: '',

  // 用户权益包数量
  rightsQuantity: 0,

  // 即将过期积分
  soonExpiredPoints: 0,

  // 用户头像
  userAvatar: require('@/assets/img/default-avatar.png'),
  userAvatarvip: require('@/assets/img/vip-avatar.png'),

  // 用户手机
  userMobile: '',

  // 用户敏感手机号
  userSensitiveMobile: '',

  // 用户昵称
  userNickname: '',

  // 果园入口
  gardenEntrance: false,

  // 果园弹窗
  gardenPop: false,

  // 果园签到状态
  gardenSigned: false,

  // 签到引导
  gardenGuide: localStorage.getItem('CHANGYO_HOME_GARDEN_GUIDE'),

  // 签到引导是否展示
  gardenGuideDisplay: false,

  // 元宝卡页面
  vipUrl: '/vip/index.html'
}

export default new Vuex.Store({
  state,
  mutations,
  getters,
  actions
})
